<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p class="title">成都灵犀点通网络科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：四川省成都市锦江区武成大街166号一层附8号</span>
      <span>Tel：198-8245-8805</span>
      <span>Fax：8888-88888888</span>
    </p>
    <p class="email_wx">
      <span>邮箱：2398328177@qq.com</span>
      <span>公司微信号：19882458805</span>
    </p>
    <p class="copy">Copyright &copy; 2023成都灵犀点通网络科技有限公司</p>
    <br>
    <a href="https://beian.miit.gov.cn/">ICP备案信息:蜀ICP备2023015221号</a>
    <p class="copy">  </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  /*background: rgb(136, 136, 136);*/
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
a {
  text-decoration: none;
  color: white;
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue